module.exports = __webpack_public_path__ + "img/eco-img.9e4c8126.png";